import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IAppointments } from '../../../../services/availableTimes.service';
import { RootState } from '../../../../store';
import {
  prepareToSelectedPhysicalAppointmentsWithMutipleAddress,
  saveCalendarSelected
} from '../../../../features/calendar/calendar-slice';
import Addresses from './Addresses';

interface IAvailableAddressProps {
  appointments: IAppointments;
}

const AvailableAddress = ({ appointments }: IAvailableAddressProps) => {
  const dispatch = useDispatch();
  const {
    calendar: { calendarsAvailables, calendarSelected, isReSchedule },
    schedule: { dateStart, selectedDay }
  } = useSelector((state: RootState) => state);

  const calendarWithOutAppointments = appointments.availableListAddress
    .filter(x => x[Object.keys(x)[0]].length === 0)
    .map(y => Object.keys(y)[0]);
  const physicalAppointments = calendarsAvailables.filter(
    item => item.type === 'PHYSICAL_APPOINTMENT' && !calendarWithOutAppointments.includes(item.id)
  );
  const vitualAppointments = calendarsAvailables.filter(item => item.type === 'VIRTUAL_CONSULTATION').map(item => item.id);
  const [availableAddress, setAvailableAddress] = useState<Record<string, boolean>>({});

  const findAvailableAddressByDate = (date: string) => {
    const array = appointments.availableListAddress.reduce(
      (acc: Record<string, boolean>, item: Record<string, string[]>) => {
        const calendarId = Object.keys(item)[0];
        if (item[calendarId].includes(date)) {
          acc[calendarId] = true;
        } else acc[calendarId] = false;
        return acc;
      },
      {}
    );
    if (calendarWithOutAppointments.length > 0) {
      calendarWithOutAppointments.forEach(item => {
        delete array[item];
      });
    }
    if (vitualAppointments.length > 0) {
      vitualAppointments.forEach(item => {
        delete array[item];
      });
    }
    return array;
  };
  useEffect(() => {
    if (calendarSelected?.type !== 'VIRTUAL_CONSULTATION') {
      setAvailableAddress(findAvailableAddressByDate(dateStart));
      if (physicalAppointments.length === 1) {
        dispatch(saveCalendarSelected({ calendar: physicalAppointments[0] }));
      }
      // Se houver mais de um endereço físico, prepara para selecionar os agendamentos físicos
      if (calendarsAvailables.length > 1) {
        dispatch(prepareToSelectedPhysicalAppointmentsWithMutipleAddress({ isReSchedule }));
      }
    }
  }, [dateStart]);

  useEffect(() => {
    if (calendarSelected?.type !== 'VIRTUAL_CONSULTATION') {
      // Se houver mais de um endereço físico, prepara para selecionar os agendamentos físicos
      if (calendarsAvailables.length > 1) {
        dispatch(prepareToSelectedPhysicalAppointmentsWithMutipleAddress({ isReSchedule }));
      }
    }
  }, [selectedDay]);

  return (
    <>
      {dateStart.length > 0 && physicalAppointments.length > 0 && calendarSelected?.type !== 'VIRTUAL_CONSULTATION' ? (
        <>
          <Addresses physicalAppointments={physicalAppointments} availability={availableAddress} />{' '}
        </>
      ) : (
        []
      )}
    </>
  );
};

export default AvailableAddress;
